import { render, staticRenderFns } from "./suggestList.vue?vue&type=template&id=54653864&scoped=true&"
import script from "./suggestList.vue?vue&type=script&lang=js&"
export * from "./suggestList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54653864",
  null
  
)

export default component.exports